import React from 'react';
import { Stack } from 'rsuite';

const Copyright = () => {
  return (
    <Stack className="copyright" justifyContent="center" style={{ height: 40, marginTop: 20 }}>
      <div className="container">
        <p>
          © {new Date().getFullYear()},{' '}
          <a href="https://x-point.tech/" target="_blank" rel="noreferrer">
            X-Point
          </a>
        </p>
      </div>
    </Stack>
  );
};

export default Copyright;
